import { ScenarioItemViewModel } from '@/interfaces'
import { useAppSelector } from '@/store/hooks'

const useScenarioStepsAvailability = (
  scenario: ScenarioItemViewModel | null
) => {
  const {
    isMetalProcessingProviderRequired,
    isBladeProcessingProviderIdRequired,
    isConcreteProcessingProviderRequired
  } = useAppSelector(s => s.scenarios)

  const isProvidersStepDisabled = !scenario?.projectId

  const isDefineScopeStepDisabled =
    isProvidersStepDisabled ||
    (isMetalProcessingProviderRequired &&
      !scenario?.metalProcessingProviderId) ||
    (isBladeProcessingProviderIdRequired &&
      !scenario?.bladeProcessingProviderId) ||
    (isConcreteProcessingProviderRequired &&
      !scenario?.concreteProcessingProviderId)

  return {
    isProvidersStepDisabled,
    isDefineScopeStepDisabled,
    isSummaryStepDisabled: isDefineScopeStepDisabled
  }
}

export default useScenarioStepsAvailability
